// Gráfica de líneas con área para la actividad mensual (servicios vs reservas).
// SVG responsivo, sin dependencias. `series`: [{ key, label, color }].
const LineActivityChart = ({ data = [], series = [], height = 280 }) => {
  const W = 760;
  const H = height;
  const pad = { top: 20, right: 24, bottom: 32, left: 48 };
  const iw = W - pad.left - pad.right;
  const ih = H - pad.top - pad.bottom;

  if (!data.length) return null;

  const allVals = data.flatMap(d => series.map(s => d[s.key] || 0));
  const maxVal = Math.max(...allVals, 4);
  const niceMax = Math.ceil(maxVal / 4) * 4 || 4;

  const x = (i) => pad.left + (data.length <= 1 ? iw / 2 : (i / (data.length - 1)) * iw);
  const y = (v) => pad.top + ih - (v / niceMax) * ih;

  const ticks = 4;
  const gridY = Array.from({ length: ticks + 1 }, (_, i) => (niceMax / ticks) * i);

  const construirPaths = (s) => {
    const pts = data.map((d, i) => [x(i), y(d[s.key] || 0)]);
    const line = pts.map((p, i) => `${i ? 'L' : 'M'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');
    const area = `${line} L${x(data.length - 1)},${pad.top + ih} L${x(0)},${pad.top + ih} Z`;
    return { line, area };
  };

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} role="img">
      {/* Líneas de cuadrícula + etiquetas Y */}
      {gridY.map((v, i) => (
        <g key={i}>
          <line x1={pad.left} y1={y(v)} x2={W - pad.right} y2={y(v)} stroke="#F1F5F9" strokeWidth="1" />
          <text x={pad.left - 10} y={y(v) + 4} textAnchor="end" fontSize="11" fill="#737791">
            {Math.round(v)}
          </text>
        </g>
      ))}

      {/* Series (área + línea) */}
      {series.map((s) => {
        const { line, area } = construirPaths(s);
        return (
          <g key={s.key}>
            <path d={area} fill={s.color} opacity="0.10" />
            <path d={line} fill="none" stroke={s.color} strokeWidth="2.5"
              strokeLinejoin="round" strokeLinecap="round" />
          </g>
        );
      })}

      {/* Etiquetas X */}
      {data.map((d, i) => (
        <text key={i} x={x(i)} y={H - 10} textAnchor="middle" fontSize="11" fill="#737791">
          {d.mes}
        </text>
      ))}
    </svg>
  );
};

export default LineActivityChart;
